/**
 * Default voice/video proximity radius (px) when a virtual room area has no
 * `proximityDistance` in its properties. Per-room overrides (e.g. large conference
 * maps) should set `properties.proximityDistance` on the VirtualRoom in Back4App.
 *
 * Keep aligned with gameplay expectations; see `VirtualRoomProximityHelper`.
 */
export const DEFAULT_PROXIMITY_FALLBACK_PX = 100
